// src/pages/CancellationRefunds.jsx
import React from "react";
import PolicyLayout from "../components/common/PolicyLayout";
import "../components/common/styles/policyPages.css";

const CancellationRefunds = () => {
  return (
    <PolicyLayout
      title="Cancellation & Refunds"
      subtitle="Understand our order cancellation, return, and refund process.">
      <div className="policy-card">
        <section id="cancellation">
          <h3 className="policy-section-title">1. Order Cancellation</h3>
          <p className="policy-section-text">
            You may request cancellation of your order before it is shipped.
            Once the order has been dispatched, cancellation may not be possible.
            To cancel your order, please reach out to us with your order ID.
          </p>
        </section>

        <section id="returns">
          <h3 className="policy-section-title">2. Returns & Replacement</h3>
          <p className="policy-section-text">
            Returns or replacements may be accepted in cases of:
          </p>
          <ul>
            <li>Damaged or defective products received.</li>
            <li>Wrong product delivered.</li>
          </ul>
          <p className="policy-section-text">
            To qualify, please raise a request within X days of delivery and
            share clear photos/videos as proof, if requested.
          </p>
        </section>

        <section id="refunds">
          <h3 className="policy-section-title">3. Refunds Process</h3>
          <p className="policy-section-text">
            Once your cancellation/return request is approved, refunds (if
            applicable) will be initiated to your original payment method or as
            store credit, as per our internal process.
          </p>
          <p className="policy-section-text">
            Refund timelines may vary depending on your bank or payment
            provider, typically within 5–7 business days after approval.
          </p>
        </section>

        <section id="nonrefundable">
          <h3 className="policy-section-title">4. Non-Refundable Items</h3>
          <p className="policy-section-text">
            Certain items or situations may not be eligible for refunds, such
            as:
          </p>
          <ul>
            <li>Products damaged due to misuse or improper handling.</li>
            <li>
              Requests raised beyond the allowed return/cancellation window.
            </li>
            <li>Products returned without original packaging or tags.</li>
          </ul>
        </section>

        <section id="contact">
          <h3 className="policy-section-title">5. Support</h3>
          <p className="policy-section-text">
            For any questions related to cancellations or refunds, please
            contact us through the details provided on the Contact Us page,
            along with your order ID for faster assistance.
          </p>
        </section>

        <div className="policy-meta">Last updated: 24/11/2025</div>
      </div>
    </PolicyLayout>
  );
};

export default CancellationRefunds;
